import type { ForumBase } from '../types/forum';
import { calculateForumScore } from './forumScore';
import { wasUpdatedWithinDays } from './forumGrowth';

export interface SearchFilters {
  q?: string;
  category?: string;
  software?: string;
  tag?: string;
  city?: string;
  minMembers?: number;
  maxMembers?: number;
  minScore?: number;
  updatedDays?: number;
  verifiedOnly?: boolean;
  activeOnly?: boolean;
}

export function filterForumsAdvanced(forums: ForumBase[], f: SearchFilters): ForumBase[] {
  let list = [...forums];
  if (f.activeOnly !== false) list = list.filter((x) => x.is_active !== false);
  if (f.q?.trim()) {
    const q = f.q.trim().toLowerCase();
    list = list.filter(
      (x) =>
        x.name.toLowerCase().includes(q) ||
        (x.description || '').toLowerCase().includes(q) ||
        x.category.toLowerCase().includes(q) ||
        (x.software || '').toLowerCase().includes(q)
    );
  }
  if (f.category) list = list.filter((x) => x.category === f.category);
  if (f.software) list = list.filter((x) => x.software === f.software);
  if (f.tag) {
    const t = f.tag.toLowerCase();
    list = list.filter((x) => (x.tags || []).some((tag) => tag.toLowerCase().includes(t)));
  }
  if (f.city) list = list.filter((x) => (x.city || '').toLowerCase() === f.city!.toLowerCase());
  if (f.minMembers != null) list = list.filter((x) => x.members_count >= f.minMembers!);
  if (f.maxMembers != null) list = list.filter((x) => x.members_count <= f.maxMembers!);
  if (f.minScore != null) {
    list = list.filter(
      (x) =>
        calculateForumScore(x.topics_count, x.posts_count, x.members_count, x.founded_year) >=
        f.minScore!
    );
  }
  if (f.updatedDays != null) list = list.filter((x) => wasUpdatedWithinDays(x, f.updatedDays!));
  if (f.verifiedOnly) list = list.filter((x) => x.is_verified === true);
  return list;
}

export function parseSearchParams(params: URLSearchParams): SearchFilters {
  return {
    q: params.get('q') || undefined,
    category: params.get('category') || undefined,
    software: params.get('software') || undefined,
    tag: params.get('tag') || undefined,
    city: params.get('city') || undefined,
    minMembers: params.get('minMembers') ? Number(params.get('minMembers')) : undefined,
    maxMembers: params.get('maxMembers') ? Number(params.get('maxMembers')) : undefined,
    minScore: params.get('minScore') ? Number(params.get('minScore')) : undefined,
    updatedDays: params.get('updatedDays') ? Number(params.get('updatedDays')) : undefined,
    verifiedOnly: params.get('verified') === '1',
    activeOnly: params.get('inactive') !== '1',
  };
}
